// extracted by mini-css-extract-plugin
module.exports = {"header":"bonusCoupon_header__2w4Hx","table":"bonusCoupon_table__kdJza"};